import React, { Component } from "react";
import Banner from "views/ilearn/ilearndetails/img/banner.png";
import coursera from "views/ilearn/ilearndetails/img/coursera.png";
import bookmark from "views/job-details/img/bookmark.png";
import share from "views/job-details/img/sharing.png";
import ReferFriendPopup from "./ReferFriendPopup";
import user from "views/ilearn/ilearndetails/img/usericon.png";
class IlearnBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isrefermodalopen: false,
    };
  }
  addDefaultSrc(ev) {
    ev.target.src = Banner;
  }
  addDefaultInstructorSrc(ev) {
    ev.target.src = user;
  }
  render() {
    const Course = this.props.Course;
    return (
      <div>
        <ReferFriendPopup
          showRefer={this.state.isrefermodalopen}
          Course={Course}
        />
        <div className="relative h-full flex items-center">
          <img
            onError={this.addDefaultSrc}
            src={`${process.env.REACT_APP_IMAGE_BASE_MG+Course.c_cover_img_path}`}
            alt="Banner"
            className="w-full py-4 maxh-396px sm-h219px"
          />

          <div className="inside-textauto-center top-18per">
            <div className="flex">
              <img src={coursera} alt="logo" className="ilearn-details-w" />
              <h1 className="font-bold sm-fsize16 fsize36 text-black ml-4">
                {Course.c_title || "The Extremes of Life"}
              </h1>
            </div>

            <div className="lg:mt-10 md:mt-10 mt-2">
              <div class="flex justify-start items-center lg:mt-4 md:mt-4">
                <div class="flex items-center mr-2">
                  <p class="fsize18 sm-fsize14 text-black font-normal">
                    Starts{" "}
                    <span className=" font-semibold">
                      {Course.start_date || "Now"}
                    </span>
                  </p>
                </div>
                <div class="flex items-center">
                  <span class="dot-point bg-bluecolor rounded-full mx-2"></span>
                  <p class="text#074A7F fsize18 sm-fsize14">
                    {" "}
                    {Course.no_of_courses} Courses ({Course.est_time}h)
                  </p>
                </div>
              </div>
              <div className="flex items-center mt-4">
                <img
                  onError={this.addDefaultInstructorSrc}
                  src={`${process.env.REACT_APP_IMAGE_BASE_MG+Course.instructor_profile_img_path}`}
                  className="ilearn-d-user-w"
                />

                <p className="fsize18 sm-fsize14 ml-3">
                  {`${Course.instructors}`.split(",")[0]}{" "}
                  {`${Course.instructors}`.split(",").length > 1 ? (
                    <span className="underline">+1 more instructor</span>
                  ) : (
                    ""
                  )}
                </p>
              </div>

              <button className="fsize16 sm-fsize12 font-bold lg:mt-8 md:mt-8 mt-2 rounded-25px filled-button  enroll-ilearn">
                ENROLL
              </button>
            </div>
          </div>
          <div className="inside-sharemark flex lg:mt-0 mt-4">
            <div className="bg-bluecolor w-h-50px  rounded-full grid justify-center items-center mr-4">
              <img src={bookmark} className="share-icon-w" />
            </div>
            <div className="bg-bluecolor w-h-50px  rounded-full grid justify-center items-center">
              <img src={share} className="share-icon-w" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IlearnBanner;
